import React from 'react';

type Props = {
  record: any,
  title: string
};

const Title = (props: Props) => (
  <span>{props.title} {props.record && props.record.name ? `"${props.record.name}"` : ''}</span>
);

export default Title;



// WEBPACK FOOTER //
// ./src/views/Common/Title.tsx